import React from "react";

import "./btBloco.css";

class BtBloco extends React.Component{
  constructor(props){
    super(props);

  }

  render(){
    var _classes = this.props.ativo ? " ativo " : "";
    _classes += " box-input bt-item-bloco js-item-bloco";
    let _datId = this.props.dataId;

    return (
      <div className="pure-u-4-24">
        <a href="#" className={_classes} data-id={_datId} onClick={this.props.onClick}>
            <div className="box-input--border">
              <div className="box-input--inner">
                <span className="item-bloco__txt">{this.props.value}</span>
              </div>
            </div>
        </a>
      </div>
    )
  }
}

export default BtBloco;



// WEBPACK FOOTER //
// ./src/components/buttons/BtBloco.js